<template>
    <div>
        <div>
            <el-button @click="createChannel" type="primary" size="small">新增推广渠道</el-button>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="channelList"
                    row-key="id"
                    height="100%">
                <el-table-column label="渠道名称" prop="channelName" align="center"/>
                <el-table-column label="渠道ID" prop="iosChannelId" align="center"/>
                <el-table-column label="渠道马甲下载数量" min-width="120" prop="downTimes" align="center"/>
                <el-table-column label="渠道转化下载数量" min-width="120" prop="successTimes" align="center"/>
                <el-table-column label="渠道备注" prop="channelDesc" align="center"/>
                <el-table-column label="落地页地址" prop="targeUrl" align="center"/>
                <el-table-column
                    align="center"
                    label="渠道落地页开关"
                    width="120">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.adOpen"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                            @change="adChange(scope.row.id,scope.row.adOpen)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editForm(scope.row)">编辑</el-button>
                        <el-button
                        @click.native.prevent="deleteRow(scope.$index, channelList,scope.row)"
                        type="danger"
                        size="mini">
                        删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="channelListTotal"
                :current-page="1"
                @current-change="()=>({})"/>
        <div v-if="dialogShow" class="common-popup-bg">
            <div class="common-popup">
                <h3>{{form.iosChannelId?'编辑':'新增'}}</h3>
                <el-form ref="ruleForm" :model="form" :auto-upload="false">
                    <table class="common-popup-table">
                        <tr>
                            <td>渠道名称：</td>
                            <td colspan="2">
                                <el-input size="medium" v-model="form.channelName"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>渠道ID：</td>
                            <td colspan="2">
                                <el-input :disabled="disableEdit" size="medium" v-model="form.iosChannelId"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="vertical-align: top">渠道备注：</td>
                            <td colspan="2">
                                <el-input type="textarea" v-model="form.channelDesc" resize="none"/>
                            </td>
                        </tr>
                        <tr>
                            <td>下载地址：</td>
                            <td colspan="2">
                                <el-input size="medium" v-model="form.targeUrl"></el-input>
                            </td>
                        </tr>
                    </table>
                </el-form>
                <footer>
                    <el-button size="small" @click="dialogShow=false">取消</el-button>
                    <el-button size="small" type="primary" @click="submit()">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                value: '',
                options: [
                    {label: '全部', value: ''},
                    {label: '俱乐部', value: '1'},
                    {label: '联盟', value: '2'}
                ],
                form:{
                    id:'',
                    iosChannelId:'',
                    channelName:'',
                    channelDesc:'',
                    targeUrl:''
                },
                dialogShow:false,
                switchStatu:"关",
                disableEdit:false
            }
        },
        computed: {
            ...mapState('channelRecord', ['channelList', 'channelListTotal'])
        },
        created() {
            this.searchChannelList()
        },
        methods:{
            ...mapActions('channelRecord', ['getChannelList', 'addChannel', 'updateChannel', 'deleteChannel','channelControl']),
            createChannel(){
                this.dialogShow = true;
                this.disableEdit = false;
                this.form = {};
            },
            editForm(row){
                this.disableEdit = true;
                this.dialogShow = true;
                this.form = row;
            },
            adChange(id,adOpen){
                debugger
                console.log(id+' '+adOpen);
                this.channelControl({
                    channelId: id,
                    adOpen: adOpen,
                    page:1
                }).then(() => {
                    this.$message.success('操作成功');
                    this.dialogShow = false;
                })
            },
            searchChannelList(obj = {}) {
                this.loading = true;
                let params = {
                    // type: this.form.type,
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getChannelList(params).then(() => {
                    this.loading = false;
                })
            },
            deleteRow(index, rows,row) {
                rows.splice(index, 1);

                //删除选中行
                this.deleteChannel({
                    id: row.id,
                    page: this.currentPage
                }).then(() => {
                    this.$message.success('删除成功');
                    this.dialogShow = false;
                })
            },
            async submit() {
                if (this.form.channelName === null) {
                    this.$message.error('输入名称');
                    return
                } else if (this.form.iosChannelId === null) {
                    this.$message.error('输入id');
                    return
                }
                debugger
                if (this.form.id) {
                    this.updateChannel({
                        params: this.form,
                        page: this.currentPage
                    }).then(() => {
                        this.$message.success('修改成功');
                        this.dialogShow = false;
                    })
                } else {
                    this.addChannel({
                        params: this.form,
                        page: this.currentPage
                    }).then(() => {
                        this.$message.success('添加成功');
                        this.dialogShow = false;
                    })
                }
            },
        }
    }
</script>